<template>
  <div  class="body">
    <div :class="box_class" class="d-box d-game" style="display: block" ref="infoBox">
      <div class="body">
          <frame1 v-if="frame == 1"/>
          <frame2 v-show="frame == 2"/>
          <frame328 v-if="frame >= 3 && frame <= 28" :ends="ends" :angle="angle" />
          <frame29 v-if="frame == 29"/>
          <frame30 v-show="frame == 30"/>
          <frame32 v-show="frame == 32"/>
          <frame33 v-show="frame == 33"/>
          <frame34 v-show="frame == 34"/>
          <Frame3135 v-if="frame == 35 || frame == 31"/>
          <frame36 v-if="frame == 36"/>
          <div class="footer" :class="frame == 31 || frame == 35? 'w-chart': ''">
            <button class="btn shadow-none" @click="nextFrame()">{{ button_start }}</button>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Frame1, Frame2, Frame328, Frame29, Frame30, Frame32, Frame33, Frame34, Frame3135, Frame36 } from '@/components/'
export default {
  name: 'home',
  components: {
    Frame1, Frame2, Frame328, Frame29, Frame30, Frame32, Frame33, Frame34, Frame3135, Frame36
  },
  data () {
    return {
      frame: 1,
      button_start: 'START',
      ends: 'conflict',
      angle: 'a1Lx',
      angles_tmp: undefined,
      box_h: 0,
      box_class: 'd-box-centered',
    }
  },
  mounted() {
    this.dboxClass()
  },
  methods: {
    ...mapMutations([
      'updateEnds'
    ]),
    ...mapActions([
      'asyncData',
      'asyncScore'
    ]),
    dboxClass() {
      this.box_h = this.$refs.infoBox.clientHeight
      if (this.box_h >= (this.window_h - 200)) {
        this.box_class = 'd-box-normal'
      }else {
        this.box_class = 'd-box-centered'
      }
    },
    nextFrame () {
      this.frame++
      var self = this
      if (this.frame < 36) {
        setTimeout(function(){ 
          self.asyncData({
            model: 'progress',
            data: self.progress + 2.86
          })
        }, 0)        
        if (this.frame > 1) {
          this.button_start = 'NEXT'
        } else {
          this.button_start = 'START'
        }
        if (this.frame >= 3 && this.frame <= 28) {
          this.angles_tmp = JSON.parse(JSON.stringify(this.angles))
          var index = Math.floor(Math.random() * this.angles.length)
          this.angle = this.angles[index]
          if (this.angle.includes('o')) {
            this.ends = 'same'
          } else {
            this.ends = 'conflict'
          }
          this.angles_tmp.splice(index, 1)
          this.asyncData({
            model: 'angles',
            data: this.angles_tmp
          })
        }
      } else if (this.frame === 36) {
        setTimeout(function(){ 
          self.asyncData({
            model: 'progress',
            data: 100
          })
        }, 0)  
        this.button_start = 'TRY AGAIN'
      } else {
        this.frame = 1
        this.button_start = 'START'
        this.asyncData({
          model: 'progress',
          data: 0
        })
        this.asyncData({
          model: 'angles',
          data: this.angles_origin
        })
        this.updateEnds()
      }
    }
  },
  computed: {
    ...mapGetters([
      'getData'
    ]),
    window_h () {
      return this.getData('window_h')
    },
    progress () {
      return this.getData('progress')
    },
    angles () {
      return this.getData('angles')
    },
    angles_origin () {
      return this.getData('angles_origin')
    }
  },
  watch: {
    progress(val) {
      this.dboxClass()
    },
  }
}
</script>
